"use client";

import {
  Lock as ReactLock,
  LockCircle as ReactLockCircle,
  LockFlatTop as ReactLockFlatTop,
  LockRoundBottom as ReactLockRoundBottom,
  LockRoundedSquare as ReactLockRoundedSquare,
  LockSquare as ReactLockSquare,
} from "./deprecated/Lock";

export const Lock = ReactLock;
export const LockCircle = ReactLockCircle;
export const LockFlatTop = ReactLockFlatTop;
export const LockRoundBottom = ReactLockRoundBottom;
export const LockRoundedSquare = ReactLockRoundedSquare;
export const LockSquare = ReactLockSquare;
